var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect, useCallback, useRef } from 'react';
import { resolveSuperAdminFlags } from '../utils/superAdmin';
// 认证Hook
export var useAuth = function (config) {
    // 完全禁用调试信息输出
    // if (process.env.NODE_ENV === 'development') {
    //   console.log('[useAuth] Hook 开始初始化');
    // }
    var _a = useState({
        isAuthenticated: false,
        token: null,
        user: null,
        loading: true,
        error: null,
        permissions: [],
    }), authState = _a[0], setAuthState = _a[1];
    // 防重复调用标志
    var _b = useState(false), isChecking = _b[0], setIsChecking = _b[1];
    // 防抖机制，避免频繁认证检查
    var debounceRef = useRef(null);
    var lastCheckRef = useRef(0);
    // 完全禁用调试信息输出
    // if (process.env.NODE_ENV === 'development') {
    //   console.log('[useAuth] 初始状态:', authState);
    // }
    // 检查认证状态
    var checkAuth = useCallback(function (silent) {
        if (silent === void 0) { silent = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var now, token, apiBaseUrl, hostname, authEndpoint, finalApiBaseUrl, response, result, raw, userData, verifyError_1, parts, payload, perms, rawJwt, userData, error_1;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        // 防止重复调用
                        if (isChecking) {
                            // 完全禁用调试信息输出
                            // if (process.env.NODE_ENV === 'development') {
                            //   console.log('[useAuth] 认证检查正在进行中，跳过重复调用');
                            // }
                            return [2 /*return*/];
                        }
                        now = Date.now();
                        if (now - lastCheckRef.current < 2000) { // 增加到2秒内不重复检查
                            // 完全禁用调试信息输出
                            // if (process.env.NODE_ENV === 'development') {
                            //   console.log('[useAuth] 防抖机制：跳过频繁的认证检查');
                            // }
                            return [2 /*return*/];
                        }
                        // 完全禁用调试信息输出
                        // if (process.env.NODE_ENV === 'development') {
                        //   console.log('[useAuth] checkAuth 函数被调用');
                        // }
                        setIsChecking(true);
                        // 静默模式下不设置loading，避免页面闪烁
                        if (!silent) {
                            setAuthState(function (prev) { return (__assign(__assign({}, prev), { loading: true, error: null })); });
                        }
                        lastCheckRef.current = now;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 7, 8, 9]);
                        token = localStorage.getItem('token') ||
                            sessionStorage.getItem('token') ||
                            localStorage.getItem('mslogin_token') ||
                            sessionStorage.getItem('mslogin_token');
                        // 完全禁用调试信息输出
                        // if (process.env.NODE_ENV === 'development') {
                        //   console.log('[useAuth] Token检查结果:', {
                        //     hasToken: !!token,
                        //     tokenLength: token ? token.length : 0,
                        //     tokenPreview: token ? token.substring(0, 20) + '...' : 'null',
                        //     localStorage: {
                        //       token: localStorage.getItem('token') ? 'exists' : 'null',
                        //       mslogin_token: localStorage.getItem('mslogin_token') ? 'exists' : 'null'
                        //     },
                        //     sessionStorage: {
                        //       token: sessionStorage.getItem('token') ? 'exists' : 'null',
                        //       mslogin_token: sessionStorage.getItem('mslogin_token') ? 'exists' : 'null'
                        //     }
                        //   });
                        // }
                        if (!token) {
                            // 完全禁用调试信息输出
                            // if (process.env.NODE_ENV === 'development') {
                            //   console.log('[useAuth] 没有找到token，认证失败');
                            // }
                            setAuthState({
                                isAuthenticated: false,
                                token: null,
                                user: null,
                                loading: false,
                                error: null,
                                permissions: [],
                            });
                            return [2 /*return*/];
                        }
                        _e.label = 2;
                    case 2:
                        _e.trys.push([2, 5, , 6]);
                        apiBaseUrl = void 0;
                        // 混合模式：useAuth 只使用环境变量配置自己的API地址
                        // 服务发现应该用于获取其他微服务的地址，而不是自己的地址
                        if ((config === null || config === void 0 ? void 0 : config.enableServiceDiscovery) && (config === null || config === void 0 ? void 0 : config.serviceName)) {
                            console.warn('[useAuth] 警告：服务发现不应用于获取当前微服务自己的API地址');
                            console.warn('[useAuth] 建议：请设置环境变量 REACT_APP_API_BASE_URL 或使用 enableServiceDiscovery: false');
                        }
                        // 始终使用环境变量配置自己的API地址
                        apiBaseUrl = (typeof window !== 'undefined' && window.REACT_APP_API_BASE_URL) ||
                            process.env.REACT_APP_API_BASE_URL ||
                            (typeof window !== 'undefined' && window.REACT_APP_API_URL) ||
                            process.env.REACT_APP_API_URL || '';
                        // 启用调试信息输出
                        if (process.env.NODE_ENV === 'development') {
                            console.log('[useAuth] 环境变量检查:', {
                                window_REACT_APP_API_BASE_URL: (typeof window !== 'undefined' && window.REACT_APP_API_BASE_URL),
                                process_env_REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
                                window_REACT_APP_API_URL: (typeof window !== 'undefined' && window.REACT_APP_API_URL),
                                process_env_REACT_APP_API_URL: process.env.REACT_APP_API_URL,
                                finalApiBaseUrl: apiBaseUrl
                            });
                        }
                        // 如果环境变量未配置，根据当前域名判断API地址
                        if (!apiBaseUrl) {
                            if (typeof window !== 'undefined' && window.location) {
                                hostname = window.location.hostname;
                                // 生产环境：根据域名判断使用统一的后端API地址
                                if (hostname.includes('homaxs.com')) {
                                    // 生产环境统一使用 www.homaxs.com 作为后端API地址
                                    apiBaseUrl = 'http://www.homaxs.com';
                                    console.log('[useAuth] 生产环境，使用统一后端API地址:', apiBaseUrl);
                                }
                                else {
                                    // 开发环境或本地环境，使用当前域名
                                    apiBaseUrl = "".concat(window.location.origin);
                                    console.log('[useAuth] 环境变量未配置，使用当前域名:', apiBaseUrl);
                                }
                            }
                            else {
                                // 开发环境 fallback
                                console.warn('[useAuth] 环境变量未配置，使用开发环境默认配置');
                                apiBaseUrl = 'http://localhost:50090';
                            }
                        }
                        // 检查是否有重复的 /api
                        if (apiBaseUrl.endsWith('/api/api')) {
                            console.error('[useAuth] 检测到重复的 /api 路径，自动修复:', apiBaseUrl);
                            apiBaseUrl = apiBaseUrl.replace('/api/api', '/api');
                        }
                        authEndpoint = (typeof window !== 'undefined' && window.REACT_APP_AUTH_ENDPOINT) ||
                            process.env.REACT_APP_AUTH_ENDPOINT ||
                            '/api/auth/verify';
                        finalApiBaseUrl = apiBaseUrl;
                        // 启用调试信息输出
                        if (process.env.NODE_ENV === 'development') {
                            console.log('[useAuth] 使用API配置:', { apiBaseUrl: apiBaseUrl, finalApiBaseUrl: finalApiBaseUrl, authEndpoint: authEndpoint });
                            console.log('[useAuth] 发送认证请求到:', "".concat(finalApiBaseUrl).concat(authEndpoint));
                            console.log('[useAuth] 认证请求token:', token ? "".concat(token.substring(0, 20), "...") : 'null');
                        }
                        return [4 /*yield*/, fetch("".concat(finalApiBaseUrl).concat(authEndpoint), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({ token: token }),
                            })];
                    case 3:
                        response = _e.sent();
                        return [4 /*yield*/, response.json()];
                    case 4:
                        result = _e.sent();
                        // 启用调试信息输出
                        if (process.env.NODE_ENV === 'development') {
                            console.log('[useAuth] 认证响应结果:', result);
                            console.log('[useAuth] 响应数据结构:', {
                                success: result.success,
                                data: result.data,
                                dataValid: (_a = result.data) === null || _a === void 0 ? void 0 : _a.valid,
                                dataAdmin: (_b = result.data) === null || _b === void 0 ? void 0 : _b.admin,
                                dataAdminKeys: ((_c = result.data) === null || _c === void 0 ? void 0 : _c.admin) ? Object.keys(result.data.admin) : 'no admin data'
                            });
                        }
                        if (result.success && result.data.valid) {
                            // 启用调试信息输出
                            if (process.env.NODE_ENV === 'development') {
                                console.log('[useAuth] 认证成功，设置认证状态');
                                console.log('[useAuth] 用户信息:', result.data.payload || result.data.admin);
                            }
                            raw = result.data.payload || result.data.admin;
                            if (!raw) {
                                throw new Error('认证响应中缺少用户数据');
                            }
                            userData = __assign(__assign({}, raw), resolveSuperAdminFlags(raw));
                            setAuthState({
                                isAuthenticated: true,
                                token: token,
                                user: userData,
                                loading: false,
                                error: null,
                                permissions: userData.permissions || [],
                            });
                            try {
                                localStorage.setItem('mslogin_user', JSON.stringify(userData));
                            }
                            catch (_f) {
                                /* ignore */
                            }
                            // 完全禁用调试信息输出
                            // if (process.env.NODE_ENV === 'development') {
                            //   console.log('[useAuth] 认证状态已设置:', {
                            //     isAuthenticated: true,
                            //     hasToken: !!token,
                            //     hasUser: !!result.data.admin
                            //   });
                            // }
                        }
                        else {
                            // Token无效，清除本地存储
                            localStorage.removeItem('token');
                            sessionStorage.removeItem('token');
                            setAuthState({
                                isAuthenticated: false,
                                token: null,
                                user: null,
                                loading: false,
                                error: 'Token已过期或无效',
                                permissions: [],
                            });
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        verifyError_1 = _e.sent();
                        // 网络/解析失败时不要用占位用户（会导致权限为空、账号 unknown）
                        try {
                            parts = token.split('.');
                            if (parts.length < 2)
                                throw verifyError_1;
                            payload = JSON.parse(atob(parts[1]));
                            perms = Array.isArray(payload.permissions) ? payload.permissions : [];
                            rawJwt = __assign(__assign({}, payload), { permissions: perms });
                            userData = __assign({ id: String((_d = payload.adminId) !== null && _d !== void 0 ? _d : ''), account: payload.account, admin_name: payload.account, roles: payload.roles || [], permissions: perms }, resolveSuperAdminFlags(rawJwt));
                            setAuthState({
                                isAuthenticated: true,
                                token: token,
                                user: userData,
                                loading: false,
                                error: null,
                                permissions: perms,
                            });
                            try {
                                localStorage.setItem('mslogin_user', JSON.stringify(userData));
                            }
                            catch (_g) {
                                /* ignore */
                            }
                        }
                        catch (_h) {
                            setAuthState({
                                isAuthenticated: false,
                                token: null,
                                user: null,
                                loading: false,
                                error: '无法验证登录状态',
                                permissions: [],
                            });
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        error_1 = _e.sent();
                        // 静默模式下，验证失败时不更新状态，保持当前状态
                        if (!silent) {
                            setAuthState({
                                isAuthenticated: false,
                                token: null,
                                user: null,
                                loading: false,
                                error: error_1 instanceof Error ? error_1.message : '认证检查失败',
                                permissions: [],
                            });
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        setIsChecking(false);
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    }, [isChecking]);
    // 登录
    var login = useCallback(function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var apiBaseUrl, authEndpoint, response, userData, error_2, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 9, , 10]);
                    localStorage.setItem('token', token);
                    localStorage.setItem('mslogin_token', token);
                    sessionStorage.setItem('mslogin_token', token);
                    if (!!isChecking) return [3 /*break*/, 8];
                    setIsChecking(true);
                    setAuthState(function (prev) { return (__assign(__assign({}, prev), { loading: true, error: null })); });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    apiBaseUrl = (typeof window !== 'undefined' && window.REACT_APP_API_BASE_URL) ||
                        process.env.REACT_APP_API_BASE_URL ||
                        (typeof window !== 'undefined' && window.REACT_APP_API_URL) ||
                        process.env.REACT_APP_API_URL || 'http://localhost:50090/api';
                    authEndpoint = (typeof window !== 'undefined' && window.REACT_APP_AUTH_ENDPOINT) ||
                        process.env.REACT_APP_AUTH_ENDPOINT ||
                        '/api/auth/verify';
                    return [4 /*yield*/, fetch("".concat(apiBaseUrl).concat(authEndpoint), {
                            method: 'GET',
                            headers: {
                                'Authorization': "Bearer ".concat(token),
                                'Content-Type': 'application/json',
                            },
                        })];
                case 2:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    userData = _b.sent();
                    setAuthState({
                        isAuthenticated: true,
                        token: token,
                        loading: false,
                        error: null,
                        user: userData.user || userData,
                        permissions: ((_a = (userData.user || userData)) === null || _a === void 0 ? void 0 : _a.permissions) || [],
                    });
                    return [3 /*break*/, 5];
                case 4: throw new Error('认证失败');
                case 5: return [3 /*break*/, 8];
                case 6:
                    error_2 = _b.sent();
                    setAuthState(function (prev) { return (__assign(__assign({}, prev), { isAuthenticated: false, loading: false, error: error_2 instanceof Error ? error_2.message : '认证检查失败', permissions: [] })); });
                    return [3 /*break*/, 8];
                case 7:
                    setIsChecking(false);
                    return [7 /*endfinally*/];
                case 8: return [3 /*break*/, 10];
                case 9:
                    error_3 = _b.sent();
                    setAuthState(function (prev) { return (__assign(__assign({}, prev), { loading: false, error: error_3 instanceof Error ? error_3.message : '登录失败', permissions: [] })); });
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); }, [isChecking]);
    // 登出
    var logout = useCallback(function () {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        localStorage.removeItem('mslogin_token');
        sessionStorage.removeItem('mslogin_token');
        localStorage.removeItem('mslogin_user');
        localStorage.removeItem('mslogin_refresh_token');
        setAuthState({
            isAuthenticated: false,
            token: null,
            user: null,
            loading: false,
            error: null,
            permissions: [],
        });
    }, []);
    useEffect(function () {
        // 先检查本地缓存，如果有用户信息且token存在，先使用缓存，避免立即显示loading
        var token = localStorage.getItem('token') ||
            sessionStorage.getItem('token') ||
            localStorage.getItem('mslogin_token') ||
            sessionStorage.getItem('mslogin_token');
        var cachedUser = localStorage.getItem('mslogin_user');
        // 如果有token和缓存的用户信息，先使用缓存，避免页面闪烁
        if (token && cachedUser) {
            try {
                var userData = JSON.parse(cachedUser);
                var permissions = userData.permissions || [];
                // 先设置缓存状态，不显示loading
                setAuthState({
                    isAuthenticated: true,
                    token: token,
                    user: userData,
                    loading: false,
                    error: null,
                    permissions: permissions,
                });
                // 然后在后台静默验证token（不显示loading）
                // 防抖执行认证检查
                if (debounceRef.current) {
                    clearTimeout(debounceRef.current);
                }
                debounceRef.current = setTimeout(function () {
                    // 静默验证，不设置loading状态
                    checkAuth(true).catch(function () {
                        // 验证失败时保持缓存状态，不强制跳转
                    });
                }, 1000); // 延迟1秒后验证，避免影响页面切换
                return function () {
                    if (debounceRef.current) {
                        clearTimeout(debounceRef.current);
                    }
                };
            }
            catch (error) {
                // 缓存解析失败，继续正常流程
                console.warn('[useAuth] 缓存用户信息解析失败，使用正常验证流程');
            }
        }
        // 没有缓存时，执行正常认证检查
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(function () {
            checkAuth();
        }, 500); // 增加到500ms 防抖延迟
        return function () {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
        };
    }, []); // 移除 checkAuth 依赖，避免循环依赖
    // 权限检查函数
    var hasPermission = useCallback(function (permission) {
        return authState.permissions.includes(permission);
    }, [authState.permissions]);
    var hasAnyPermission = useCallback(function (permissions) {
        return permissions.some(function (permission) { return authState.permissions.includes(permission); });
    }, [authState.permissions]);
    var hasAllPermissions = useCallback(function (permissions) {
        return permissions.every(function (permission) { return authState.permissions.includes(permission); });
    }, [authState.permissions]);
    return __assign(__assign({}, authState), { checkAuth: checkAuth, login: login, logout: logout, hasPermission: hasPermission, hasAnyPermission: hasAnyPermission, hasAllPermissions: hasAllPermissions });
};
